import { AutogenModelMarketrateExprt, AutogenRowMarketrateExprt } from "./autogen/AutogenModelMarketrateExprt";

export class ModelMarketrateExprt extends AutogenModelMarketrateExprt<RowMarketrateExprt> {
	constructor() {
		super(RowMarketrateExprt);
	}
}

export class RowMarketrateExprt extends AutogenRowMarketrateExprt {
}